import RateReviewAfterChat from './rate_review_after_chat';

export default RateReviewAfterChat;
